module.exports = __webpack_public_path__ + "static/media/focus-productivity-procrastination@3x.b72e874c.png";